<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" md="10" lg="8">
        <div class="text-center mb-8">
          <img src="/img/Harvia_sauna_spa-logo.svg" height="120px" width="120px" alt="Harvia" />
          <h1 class="text-h4 text-md-h3 mt-4 mb-2">{{ $t('home.title') }}</h1>
          <p class="text-body-1 text-md-h6 mb-0 secondary--text subtitle-text">{{ $t('home.subtitle') }}</p>
        </div>

        <v-row justify="center" class="agent-cards">
          <v-col cols="12" md="6">
            <v-card outlined class="agent-card pa-6 text-center fill-height d-flex flex-column" @click="goTo('sales')">
              <v-icon size="80" color="primary" class="mt-2 mb-4">mdi-cart-outline</v-icon>
              <h2 class="text-h5 mb-3">{{ $t('home.sales_title') }}</h2>
              <p class="text-body-1 mb-6 flex-grow-1 subtitle-text">{{ $t('home.sales_description') }}</p>
              <v-btn color="primary" large block @click.stop="goTo('sales')">
                {{ $t('home.choose_sales') }}
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card outlined class="agent-card pa-6 text-center fill-height d-flex flex-column" @click="goTo('support')">
              <v-icon size="80" color="primary" class="mt-2 mb-4">mdi-message-question-outline</v-icon>
              <h2 class="text-h5 mb-3">{{ $t('home.support_title') }}</h2>
              <p class="text-body-1 mb-6 flex-grow-1 subtitle-text">{{ $t('home.support_description') }}</p>
              <v-btn color="primary" large block @click.stop="goTo('support')">
                {{ $t('home.choose_support') }}
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getActiveRegionKey } from '@/config/regions';

export default {
  name: 'HomeView',
  mounted() {
    // Show language selector first; once a language is chosen, terms popup is shown
    // automatically (see App.vue's onLanguageSelected). If both have already been
    // handled in a previous visit, neither dialog appears.
    this.$nextTick(() => {
      const stored = localStorage.getItem('harvia-language');
      const termsAccepted = localStorage.getItem('termsAccepted');
      if (!stored) {
        this.$root.$emit('show-language-selector');
      } else if (!termsAccepted) {
        this.$root.$emit('show-terms-popup');
      }
    });
  },
  methods: {
    goTo(agent) {
      const locale = this.$i18n.locale;
      const region = getActiveRegionKey();
      this.$router.push({ path: `/${agent}`, query: { language: locale, region } });
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle-text {
  white-space: pre-line;
}

.agent-card {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  border-width: 2px !important;
}

.agent-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
}
</style>
